var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:`style-guide-section || constrain-width`},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('hr',{staticClass:"style-guide-line"}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }